import React, { useState } from 'react';
import './Header.css';
import AA_PB_Logo from "../../Assets/img/logooaa.png";

const Header = () => {
  const [isMenuActive, setIsMenuActive] = useState(false);

  const handleHamburgerClick = () => {
    setIsMenuActive(!isMenuActive);
  };

  const handleNavLinkClick = () => {
    setIsMenuActive(false);
  };

  return (
    <header>
      <div className="aa-pb-container">
        <nav className="nav-bar py-[10px] sm:py-[20px]">
          <a href="#" className="nav-branding">
            <img src={AA_PB_Logo} alt='aa-photoboth-360' className='max-w-[60px] sm:max-w-[100px]' />
          </a>

          <ul className={`nav-menu pt-[20px] sm:pt-0 ${isMenuActive ? 'active' : ''}`}>
            <li className="nav-item">
              <a href="#" className="nav-link" onClick={handleNavLinkClick}>Home</a>
            </li>
            <li className="nav-item">
              <a href="#" className="nav-link" onClick={handleNavLinkClick}>360</a>
            </li>
            <li className="nav-item">
              <a href="#" className="nav-link" onClick={handleNavLinkClick}>Photo Booth</a>
            </li>
            <li className="nav-item">
              <a href="#" className="nav-link" onClick={handleNavLinkClick}>Client Portal</a>
            </li>
            <li className="nav-item">
              <a href="#" className="nav-link" onClick={handleNavLinkClick}>Team</a>
            </li>
            <button className='uppercase font-poppins-regular text-[#fff] text-[15px] bg-[#000] hover:opacity-[0.8] px-[32px] py-[16px] rounded-[40px]'> Call Now </button>
          </ul>

          <div className={`hamburger ${isMenuActive ? 'active' : ''}`} onClick={handleHamburgerClick}>
            <div className="strip burger-strip">
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
